export default __webpack_public_path__ + "static/media/becircular_logo.e614aa22.png";